export const FORM_ACTION_IDS = {
  CLONE: 'clone',
  CREATE_LIST: 'create-list',
  CREATE_TRANSLATION: 'translate',
  EDIT_NON_HS_EMAIL_NOTIFICATIONS: 'edit-non-hs-email-notifications',
  EDIT_NON_HS_MAILCHIMP_LIST: 'edit-non-hs-mailchimp-list',
  EXPORT_SUBMISSIONS: 'export-submissions',
  RENAME: 'rename-form',
  SELECT_CAMPAIGN: 'select-campaign',
  SHARE: 'share-form',
  UNPUBLISH: 'unpublish',
  VIEW_DETAILS: 'view-performance',
  VIEW_FILE_UPLOADS: 'view-file-uploads',
  VIEW_SUBMISSIONS: 'view-submissions',
  VIEW: 'test-form',
  WORDPRESS_COPY_SHORT_CODE: 'wordpress-copy-shortcode',
  SUMMARIZE: 'summarize',
  CREATE_CUSTOMER_AGENT_ACTION: 'create-customer-agent-action'
};